<template>
  <modal name="intersection" height="auto" :width="850" :pivotX="windowWidth > 900 ? 0 : 0.5" :pivotY=".15">
  <section class="intersection intersection__twocolumns">
    <div class="close-button" @click="hide"></div>
    <aside class="window window__content window__content--dark">
      <header class="window__header">
        <figure class="intersection__logo">
          <img :src="image" class="intersection__logo__source" />
        </figure>

        <h1 class="window__title">Sell something new</h1>
        <p class="window__description">
          Built for digital advertising salespeople. High impact and low cost display advertising that will impress your clients and boost renewals.
        </p>
      </header>

      <footer>
        <a href="#" class="window__button button button--primary button--expand" v-on:click.prevent="showSignUp">Don't have an account? Sign up</a>
        <a href="#" class="window__button button button--tertiary button--expand button--google" v-on:click.prevent="doGoogleSignUp">Sign Up with Google</a>
      </footer>
    </aside>
    <aside class="window window__content">
      <sign-in></sign-in>
    </aside>
  </section>
</modal>
</template>

<script>

import image from "../../assets/logo-parkave-light.png"
import signIn from './SignIn'
import { oauthLogin } from "../../lib/oauth"

let hideModal = function(){
  this.$modal.hide('intersection')
}

export default {
  name: 'Intersection',
  components: {
    signIn
  },
  methods: {
    hide () {
      hideModal.call(this);
    },
    showSignIn () {
      hideModal.call(this);
      this.$modal.show('sign-in')
    },
    showSignUp () {
      hideModal.call(this);
      this.gtag_click();
      this.$modal.show('sign-up')
    },
    doGoogleSignUp(e){
      e.preventDefault();
      this.gtag_click()
      oauthLogin('google', true);
    },
    gtag_click(url) {
      var callback = function () {
        if (typeof(url) != 'undefined') {
          window.location = url;
        }
      };
      gtag('event', 'conversion', {
        'send_to': 'AW-1005669616/Xdc2CPya6eMBEPCZxd8D',
        'event_callback': callback
      });
      return false;
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  },
  data(){
    return {
      image,
      windowWidth: window.innerWidth
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/Intersection.vue